import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <XCircle className="w-20 h-20 text-orange-500 mx-auto" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          Zahlung abgebrochen
        </h1>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Du hast den Zahlungsvorgang abgebrochen. Keine Sorge, es wurden keine Kosten verrechnet.
        </p>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-800 dark:text-blue-200">
            💡 Du kannst jederzeit erneut upgraden und von allen Premium-Features profitieren.
          </p>
        </div>
        
        <div className="flex gap-3">
          <button
            onClick={() => navigate('/')}
            className="flex-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Zurück zum Dashboard
          </button>
          <button
            onClick={() => window.history.back()}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Nochmal versuchen
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;